// Helpers partages du module Etat des salaires.

export const formatMontant = (value) => `${Math.round(Number(value || 0)).toLocaleString('fr-FR').replace(/,/g, ' ')} FCFA`;

export const formatMonthLabel = (month) => {
  if (!month) return 'Mois non défini';
  return `${month.nom || month.nom_mois || 'Mois'} ${month.annee_civile || month.annee || ''}`.trim();
};

export const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('fr-FR');
};

export const normalizeFilePart = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-zA-Z0-9_-]+/g, '-')
  .replace(/^-+|-+$/g, '')
  .toLowerCase();

// Categories de paie -- chaque bloc reprend une teinte du langage MaCaisse.
export const CATEGORIES_TONES = {
  hybrides: { border: 'border-cyan-200', bg: 'bg-cyan-50/30', header: 'bg-cyan-50 border-cyan-200', title: 'text-cyan-900', sub: 'text-cyan-700', th: 'bg-cyan-100 border-cyan-200 text-cyan-900', row: 'hover:bg-cyan-50', divide: 'divide-cyan-100' },
  personnel: { border: 'border-purple-200', bg: 'bg-purple-50/30', header: 'bg-purple-50 border-purple-200', title: 'text-purple-900', sub: 'text-purple-700', th: 'bg-purple-100 border-purple-200 text-purple-900', row: 'hover:bg-purple-50', divide: 'divide-purple-100' },
  enseignantsFixes: { border: 'border-blue-200', bg: 'bg-blue-50/30', header: 'bg-blue-50 border-blue-200', title: 'text-blue-900', sub: 'text-blue-700', th: 'bg-blue-100 border-blue-200 text-blue-900', row: 'hover:bg-blue-50', divide: 'divide-blue-100' },
  // Meme bleu pale que les enseignants fixes : l'ambre saturait visuellement une categorie
  // qui contient beaucoup de lignes. Les alertes de la colonne "Lecture" restent en ambre.
  enseignantsHoraires: { border: 'border-blue-200', bg: 'bg-blue-50/30', header: 'bg-blue-50 border-blue-200', title: 'text-blue-900', sub: 'text-blue-700', th: 'bg-blue-100 border-blue-200 text-blue-900', row: 'hover:bg-blue-50', divide: 'divide-blue-100' }
};
